import $ from "jquery";
var slider_bars = "\n    <i class=\"slider__bar slider__bar--vertical\" aria-hidden=\"true\"></i>\n    <i class=\"slider__bar slider__bar--horizontal\" aria-hidden=\"true\"></i>\n";
var slider_arrow = "\n    <i aria-hidden=\"true\" class=\"fal fa-angle-down fa-lg\"></i>\n";
$(".off-canvas__menu .menu-item-has-children > a").append("<button aria-label=\"Expand menu\" class=\"slider js-submenu-slider\">\n        ".concat(slider_arrow, "\n    </<button>")); // Expand/collapse on-click

$(".js-submenu-slider").click(function (e) {
  e.preventDefault();
  $(this).toggleClass("active").parent().siblings(".sub-menu").finish().slideToggle();
}); // Add class to the body tag to prevent page scrolling when the off-canvas menu is open

var $offcanvas_toggle = $('.off-canvas__toggle, .off-canvas > .close-button');
$offcanvas_toggle.on('click', function (event) {
  document.body.classList.toggle('js-prevent-vertical-scrolling');
});